import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';

@Component({
  selector: 'app-bulk-production',
  standalone: false,
  templateUrl: './bulk-production.component.html',
  styleUrl: './bulk-production.component.scss',
})
export class BulkProductionComponent implements OnInit {
  @Output() routeConfig = new EventEmitter<any>();
  @Input() urls:any={GPUrl:'/revenue/bulk/production/',TGPUrl:'/revenue/bulk-production/dates/'};
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() proposalId: any;
  @Input() proposalName: any;

  commentForm: FormGroup;
  payload: { proposal_id: any; proposal_name: any };
  apiUrl = environment.APIUrl;
  userID = sessionStorage.getItem('user_role_id');
  finalOfferFilePath: string | null = null;
  rfpdata: any;
  productionDates: any[] = [];
  resId: any;
  init: EditorComponent['init'] = init;
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.commentForm = this.fb.group({ final_offer: [''], date: [''],bpc_issue_date: [''] });
    if(this.stepDetails.can_edit){
      this.commentForm.enable();
    }else{
      this.commentForm.disable();

    }
    this.getRfpDetails();
  }

    getRfpDetails() {
    this.api.getAPI(`${this.urls.GPUrl}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
     
      const rfp = res;
      this.rfpdata = rfp;
      this.commentForm.patchValue({
        final_offer: rfp?.justification || '',
        bpc_issue_date: rfp?.bpc_issue_date || '',
      });
      this.productionDates = Array.isArray(rfp?.bulk_dates || rfp?.bulktdf_dates)
        ? (rfp.bulk_dates || rfp.bulktdf_dates).map((row: any) => ({ ...row, edit: false }))
        : [];
    });
  }

  onSubmit(): void {
    const f = this.commentForm.value;
    const formData = new FormData();
    formData.append('proposal_step', this.stepDetails.id);
    formData.append('justification', f.final_offer);
    formData.append('bpc_issue_date', f.bpc_issue_date);

    const handleSuccess = (msg: string) => {
      this.getRfpDetails();
      this.messageService.add({ severity: 'success', summary: 'Success', detail: msg });
    };

    if (this.rfpdata?.id) {
      this.api.putAPI(`${this.urls.GPUrl}${this.rfpdata.id}/`, formData)
        .subscribe((res: any) => {
          handleSuccess(res.message || 'Offer updated successfully');
        });
    } else {
      this.api.postAPI(this.urls.GPUrl, formData)
        .subscribe((res: any) => handleSuccess(res.message || 'Offer uploaded successfully'));
    }
  }

  addProductionDateRow() {
    this.productionDates = this.productionDates || [];
    this.productionDates.push({ hat_date: '', fat_date: '', sat_date: '', bulk_delivery_date: '', edit: true });
  }

  saveProductionDateRow(row: any) {
    if (!row.hat_date && !row.fat_date && !row.sat_date && !row.bulk_delivery_date) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'At least one date field is required'
      });
      return;
    }
    const payload = {
      hat_date: row.hat_date || null,
      fat_date: row.fat_date || null,
      sat_date: row.sat_date || null,
      bulk_delivery_date: row.bulk_delivery_date || null,
      ...(row.id ? {} : { bulk_production: this.rfpdata?.id })
    };
    const onSuccess = (msg: string, res?: any) => {
      row.edit = false;
      if (res?.id) row.id = res.id;
      this.messageService.add({ severity: 'success', summary: 'Success', detail: msg });
      this.getRfpDetails();
    };
    const onError = (err: any, failedMsg: string) =>
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.detail || err?.error?.message || failedMsg
      });

    if (row.id) {
      this.api.putAPI(`${this.urls.TGPUrl}${row.id}/`, payload)
        .subscribe({
          next: (res: any) => onSuccess(res.message || 'Production date updated successfully'),
          error: (err) => onError(err, 'Failed to update production date')
        });
    } else {
      this.api.postAPI(this.urls.TGPUrl, payload)
        .subscribe({
          next: (res: any) => onSuccess(res.message || 'Production date created successfully', res),
          error: (err) => onError(err, 'Failed to create production date')
        });
    }
  }
}
